export class Holiday {
  constructor(
    public hash: string,
    public date: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/calendar/holiday.ts